import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { InfMunCarregaInterface, infPercurso, SelectObjectRemoveInterface } from "../../../interfaces";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { addListaMunicipiosCarregamento, removeMunicipioCarregamento } from "../../../features/manifestoSlice";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { JConfirmDelete, MakeMessageError, MensagemModal } from "../../../components/Components";
import { getUuidV4 } from "../../../utils/utils";
import { Link } from "react-router-dom";

const initialFormMun: InfMunCarregaInterface = {
    id: 0,
    name: 'NATAL',
    municipio_id: 1161
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function MunicipioCarrega(props: any) {
    const dispatch = useDispatch();
    const form = useSelector((state: RootState) => state.manifesto.manifesto);
    const selectMunicipios = useSelector((state: RootState) => state.manifesto.selectMunicipios);
    const listaMunicipiosCarregamento = useSelector((state: RootState) => state.manifesto.manifesto.infMunCarrega);
    const listaUfPercurso = useSelector((state: RootState) => state.manifesto.manifesto.infPercurso);
    const estadoInicialRef = props.estadoInicialRef;
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [formMun, setFormMun] = useState<InfMunCarregaInterface>(initialFormMun);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showModal, setShowModal] = useState<boolean>(false);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const validarPreenchimento = () => {
        if (estadoInicialRef.current) {
            const estadoInicial = estadoInicialRef.current.value || '';
            if (estadoInicial === "") {
                alerta('Informe a UF Inicial');
                return false;
            }

            if (listaUfPercurso.find((estado: infPercurso) => estado.uf === estadoInicial)) {
                alerta('Remova a UF Inicial de UF de percurso');
                return false;
            }
            
        }

        if (formMun.municipio_id.toString() === '0') {
            alerta('Selecione um município');
            return false;
        }

        if (form.infMunCarrega.find((municipio: InfMunCarregaInterface) =>
            municipio.municipio_id === parseInt(formMun.municipio_id.toString()))) {
            alerta('Município já adicionado');
            return false;
        }

        if (form.infMunCarrega.length === 50) {
            alerta('Limite máximo de 50 locais de carregamento atingido.');
            return false;
        }
        return true;
    }

    const handleAddMunicipioCarregamento = () => {

        if (validarPreenchimento()) {
            dispatch(addListaMunicipiosCarregamento({ ...formMun, id: getUuidV4() }));
        }

    }

    const handleRemove = (id: number) => {
        dispatch(removeMunicipioCarregamento(id))
        setShowModal(false);
    }

    useEffect(() => {
        const mun = selectMunicipios.find(item => item.capital === 1)
        if (mun) {

            setFormMun(
                {
                    ...formMun,
                    municipio_id: mun.id,
                    name: mun.name
                }
            )
        }
    }, [selectMunicipios])

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header>
                <h6 className="py-0 my-1">Municípios de carregamento <span className="text-dark">(50 no máximo)</span></h6>
            </Card.Header>
            <Card.Body className="">

                <Row className="g-2">
                    <Col md={6}>
                        <Form.Group className="mb-2">

                            <Form.Select value={formMun.municipio_id} name="municipio_carregamento"
                                id="municipio_carregamento"
                                onChange={(e: any) => {
                                    setFormMun({
                                        ...formMun,
                                        municipio_id: parseInt(e.target.value),
                                        name: e.target.options[e.target.selectedIndex].text
                                    })
                                }}>
                                {selectMunicipios?.map((municipio: any) => (
                                    <option key={municipio.id}
                                        selected={municipio.capital.toString() === '1'}
                                        value={municipio.id}
                                    >
                                        {municipio.name}
                                    </option>
                                ))}
                            </Form.Select>

                        </Form.Group>
                    </Col>
                    <Col md={'auto'}>
                        <Form.Group className="mb-2">
                            <Button variant="primary" onClick={handleAddMunicipioCarregamento} >
                                <FontAwesomeIcon icon={faPlus} /> Adicionar
                            </Button>
                        </Form.Group>
                    </Col>
                    <Col md={'auto'}>

                    </Col>
                </Row>

                <Row>
                    <Col md>

                        <MakeMessageError errors={errors} field="infMunCarrega" />
                        <Table striped bordered hover size="sm" responsive="sm">
                            <thead className="table-light">
                                <tr>
                                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                                    <th>Município</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listaMunicipiosCarregamento?.map((municipio: InfMunCarregaInterface) => (
                                    <tr key={municipio.id}>
                                        <td className="text-center">
                                            <Link to={''} className="text-danger"
                                                onClick={() =>
                                                    handleOpenModal({ id: municipio.id, title: municipio.name })
                                                }
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </Link>
                                        </td>
                                        <td>{municipio.name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Card.Body>
        </Card>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemove}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />

    </>)
}
